
/**
 * Hook to get the Facebook categories
 */
const useFacebookCategories = () => {
    return [];
}

export default useFacebookCategories;